import { OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
var Formulario27Component = /** @class */ (function () {
    function Formulario27Component() {
        this.htmlcanvas = html2canvas;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.region = GLOBAL.region;
        //listas filtros
        this.perm = [];
        this.recep = [];
        this.pages = [1, 2, 3];
        //PERMISOS RECEPCION ANTERIORES
        if (JSON.parse(localStorage.getItem("perm_recep_ant")).length > 0) {
            this.perm_recep_ant = JSON.parse(localStorage.getItem("perm_recep_ant"));
        }
        else {
            localStorage.setItem("perm_recep_ant", JSON.stringify([]));
            this.perm_recep_ant = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }];
        }
        if (this.perm_recep_ant.length > 0) {
            for (var i = 0; i < this.perm_recep_ant.length; i++) {
                this.perm.push(this.perm_recep_ant[i]);
                if (this.perm.length == 0 && this.perm_recep_ant.length == (i + 1)) {
                    this.perm = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }];
                }
            }
        }
        if (this.perm.length > 0 && this.perm.length < 5) {
            for (var x = this.perm.length; x < 5; x++) {
                this.perm.push({ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null });
            }
        }
        else {
            this.perm = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }],
                [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }],
                [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }],
                [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }],
                [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }];
        }
    }
    Formulario27Component.prototype.ngOnInit = function () {
    };
    Formulario27Component.prototype.ngAfterContentChecked = function () {
        this.ngAfterContentInit();
    };
    Formulario27Component.prototype.ngAfterContentInit = function () {
        //tipo permiso
        if (localStorage.getItem("tipo_permiso")) {
            if (JSON.parse(localStorage.getItem("tipo_permiso")).length > 0) {
                this.tipo_permiso = JSON.parse(localStorage.getItem("tipo_permiso"));
            }
            else {
                localStorage.setItem("tipo_permiso", JSON.stringify([]));
                this.tipo_permiso = [{ obra: '', loteo_dfl: '', loteo_const: '', ampliacion: '', alteracion: '', reparacion: '', reconstruccion: '' }];
            }
        }
        //PROPIEDAD
        if (JSON.parse(localStorage.getItem("propiedad"))) {
            if (JSON.parse(localStorage.getItem("propiedad")).length > 0) {
                this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
            }
            else {
                localStorage.setItem("propiedad", JSON.stringify([]));
                this.propiedad = [{ rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', recordId: '' }];
            }
        }
        //PROPIETARIOS
        if (JSON.parse(localStorage.getItem("propietarios"))) {
            if (JSON.parse(localStorage.getItem("propietarios")).length > 0) {
                this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
            }
            else {
                localStorage.setItem("propietarios", JSON.stringify([]));
                this.propietarios = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //PERMISO NOTARIADO
        if (JSON.parse(localStorage.getItem("permiso_notariado"))) {
            if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0) {
                this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
            }
            else {
                localStorage.setItem("permiso_notariado", JSON.stringify([]));
                this.permiso_notariado = [{ acreditacion: '', fecha: null, escritura: null, notario: '' }];
            }
        }
        //ARQUITECTOS
        if (JSON.parse(localStorage.getItem("arquitectos"))) {
            if (JSON.parse(localStorage.getItem("arquitectos")).length > 0) {
                this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"));
            }
            else {
                localStorage.setItem("arquitectos", JSON.stringify([]));
                this.arquitectos = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }];
            }
        }
        //CONSTRUCTORES 
        if (JSON.parse(localStorage.getItem("constructores"))) {
            if (JSON.parse(localStorage.getItem("constructores")).length > 0) {
                this.constructores = JSON.parse(localStorage.getItem("constructores"));
            }
            else {
                localStorage.setItem("constructores", JSON.stringify([]));
                this.constructores = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }];
            }
        }
        //INDEPENDIENTE
        if (JSON.parse(localStorage.getItem("independiente"))) {
            if (JSON.parse(localStorage.getItem("independiente")).length > 0) {
                this.independiente = JSON.parse(localStorage.getItem("independiente"));
            }
            else {
                localStorage.setItem("independiente", JSON.stringify([]));
                this.independiente = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' }];
            }
        }
        //INSPECTOR DE OBRA
        if (JSON.parse(localStorage.getItem("inspectorObra"))) {
            if (JSON.parse(localStorage.getItem("inspectorObra")).length > 0) {
                this.inspectorObra = JSON.parse(localStorage.getItem("inspectorObra"));
            }
            else {
                localStorage.setItem("inspectorObra", JSON.stringify([]));
                this.inspectorObra = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' }];
            }
        }
        //PERMISO Y RECEPCIONES ANTERIORES
        if (JSON.parse(localStorage.getItem("perm_recep_ant"))) {
            if (JSON.parse(localStorage.getItem("perm_recep_ant")).length > 0) {
                this.perm_recep_ant = JSON.parse(localStorage.getItem("perm_recep_ant"));
            }
            else {
                localStorage.setItem("perm_recep_ant", JSON.stringify([]));
                this.perm_recep_ant = [{ permiso: '', numero: 0, fecha: null, superficie: 0, recepcion: '', fecha_recep: null }];
            }
        }
        //PROFESIONAL COMPETENTE
        if (JSON.parse(localStorage.getItem("profesionalComp"))) {
            if (JSON.parse(localStorage.getItem("profesionalComp")).length > 0) {
                this.profesionalComp = JSON.parse(localStorage.getItem("profesionalComp"));
            }
            else {
                localStorage.setItem("profesionalComp", JSON.stringify([]));
                this.profesionalComp = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' }];
            }
        }
        //TIPO PROYECTO
        if (JSON.parse(localStorage.getItem("tipo_proyecto"))) {
            if (JSON.parse(localStorage.getItem("tipo_proyecto")).length > 0) {
                this.tipo_proyecto = JSON.parse(localStorage.getItem("tipo_proyecto"));
            }
            else {
                localStorage.setItem("tipo_proyecto", JSON.stringify([]));
                this.tipo_proyecto = [{ tipo_proy1: '', tipo_proy2: '', tipo_proy3: '', tipo_proy4: '', tipo_proy5: '', tipo_proy6: '', perm_recep: '', perm_numero: '', perm_fecha: '', perm_sup: '', mod_proy_res: '', mod_proy_fech: '', rparcial_proy_res: '', sup_proy_res: '', dest_proy_res: '' }];
            }
        }
        //TIPO RECEPCION
        if (JSON.parse(localStorage.getItem("tipo_recepcion"))) {
            if (JSON.parse(localStorage.getItem("tipo_recepcion")).length > 0) {
                this.tipo_recepcion = JSON.parse(localStorage.getItem("tipo_recepcion"));
            }
            else {
                localStorage.setItem("tipo_recepcion", JSON.stringify([]));
                this.tipo_recepcion = [{ option: '' }];
            }
        }
        //INFORME REVISOR
        if (JSON.parse(localStorage.getItem("informe"))) {
            if (JSON.parse(localStorage.getItem("informe")).length > 0) {
                this.informe = JSON.parse(localStorage.getItem("informe"));
            }
            else {
                localStorage.setItem("informe", JSON.stringify([]));
                this.informe = [{ infradio: '', num_informe: '', fech_informe: null }];
            }
        }
    };
    Formulario27Component.prototype.captureScreen = function () {
        var _this = this;
        var pdf = new jspdf('p', 'mm', 'a4');
        this.htmlcanvas(document.getElementById("page1")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page2")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page3")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        setTimeout(function () {
            pdf.save(_this.propietarios[0].rut + '.pdf');
            // pdf.save('prueba.pdf')
        }, 6000);
    };
    return Formulario27Component;
}());
export { Formulario27Component };
